<template>
  <div class="j_date_picker">
    <v-menu
      v-model="menu"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :close-on-content-click="false"
      :nudge-left="nudgeLeft"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          v-bind="props"
          v-model="dateString"
          :class="textFieldClass"          
          readonly
          :clearable="clearable"
        ></v-text-field>
      </template>

      <v-date-picker
        v-model="dateObject"
        color="grey-lighten-2"
        @update:modelValue="menu = false"
      ></v-date-picker>
    </v-menu>
    <span class="icon_picker">
      <v-icon @click="menu = true">mdi-calendar</v-icon>
    </span>
  </div>
</template>

<script>
import '@/assets/stylus/ui/component/_jDatePicker.scss'

export default {
  name: 'j-date-picker',
  props: {
    modelValue: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10)
    },
    label:     { type: String,  default: 'date' },
    noBorder:  { type: Boolean, default: false },
    noDefault: { type: Boolean, default: false },
    nudgeLeft: { type: Number,  default: 0 },
    clearable: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      menu: false,
    }
  },
  computed: {
    dateString: {
      get() {
        if (!this.modelValue) {
          return this.noDefault ? '' : new Date().toISOString().substr(0, 10)
        }
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },

    dateObject: {
      get() {
        const s = this.dateString
        if (!s) {
          return new Date()
        }
        const [y, m, d] = s.split('-').map(Number)
        return new Date(y, m - 1, d)
      },
      set(date) {
        // Date → "YYYY-MM-DD" 문자열로 변환
        const yyyy = date.getFullYear()
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        this.dateString = `${yyyy}-${mm}-${dd}`
      }
    },
    textFieldClass() {
      return { 'no-border': this.noBorder }
    }
  },
  methods: {
    onMenuClose() {
      this.$nextTick(() => {
        this.menu = false
      })
      
    },
    parseDate(dateStr) {
      if (!dateStr) return new Date()
      const parts = dateStr.split('-')
      if (parts.length !== 3) return new Date()
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))
    },
  },
}
</script>
